import React from 'react';

import { Box, Container } from '@mui/material';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { BrowserRouter, Route, Routes } from 'react-router';
import { ToastContainer } from 'react-toastify';

import Loader from './components/Loader';
import Sidebar from './components/Sidebar';
import { useFetchUser } from './hooks/useFetchUser';
import { AuthorizedRoute, PrivateRoute, ROUTES_LIST } from './routes';
import UserContext from './user-context';
import NotFound from './views/NotFound';

dayjs.extend(localizedFormat);

const App = React.memo(() => {
  const user = useFetchUser();

  return (
    <UserContext.Provider value={user}>
      <React.StrictMode>
        <BrowserRouter>
          <Box
            sx={{
              backgroundColor: 'secondary.main',
              minHeight: '100vh',
              width: '100%',
              ...(user.user ? { display: 'flex', flexDirection: 'row' } : {}),
            }}
            component="main"
          >
            {user.isFetching && <Loader />}

            {!user.isFetching && (
              <>
                {user.user && <Sidebar />}

                <Box sx={{ width: '100%', height: '100vh' }}>
                  <Container
                    maxWidth={false}
                    sx={{
                      padding: user.user ? '15px 12px 12px' : null,
                      overflow: 'hidden',
                      height: '100%',
                    }}
                    disableGutters
                  >
                    <Routes>
                      {ROUTES_LIST.map(({ name, isProtected, ...route }) =>
                        isProtected ? (
                          <Route key={`private-${name}`} element={<PrivateRoute />}>
                            <Route key={name} {...route} />
                          </Route>
                        ) : (
                          <Route key={`private-${name}`} element={<AuthorizedRoute />}>
                            <Route key={name} {...route} />
                          </Route>
                        ),
                      )}

                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </Container>
                </Box>

                <ToastContainer
                  position="bottom-right"
                  autoClose={3000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  draggable={false}
                  pauseOnHover
                  pauseOnFocusLoss={false}
                  theme="colored"
                />
              </>
            )}
          </Box>
        </BrowserRouter>
      </React.StrictMode>
    </UserContext.Provider>
  );
});

export default App;
